import Hotjar from '@hotjar/browser'

import { EClientPath } from '~/models/api'
import EEnvironmentVariables from '~/models/config'

function hotJarConfig() {
  const isHotjarIdMissing = !import.meta.env[
    EEnvironmentVariables.VITE_HOTJAR_ID
  ]
  const isChatbotPage = window.location.pathname.includes(
    `${EClientPath.chatBase}/`,
  )

  if (isHotjarIdMissing || isChatbotPage) {
    return
  }

  const siteId = import.meta.env[EEnvironmentVariables.VITE_HOTJAR_ID]
  const hotjarVersion = 6

  Hotjar.init(siteId, hotjarVersion)
}

export default hotJarConfig
